import { createContext, Dispatch, SetStateAction } from 'react';
import { CrmUserRoleModel } from '@pages/crm/utils/models/CrmUserRoleModel';
import { UseQueryResult } from 'react-query';

import { crmModels } from 'modules/crm';

interface IQuery {
  startTimestamp?: number | null;
  finishTimestamp?: number | null;
  pipeStatusIds?: number[];
  responsibleById?: number[];
  createdById?: number[];
  taskStartDate?: string | null;
  taskFinishDate?: string | null;
  leadDeletedType?: string | null;
  balanceStart?: number | null;
  balanceFinish?: number | null;
  reasonsFRIds?: number[];
  tagIds?: number[];
  page?: number | null;
  size?: number | null;
  pipeId?: number | null;
  setting?: boolean;
  fields?: Record<string, string>;
  order?: string | null;
  orderField?: string | null;
  voronka?: number | null;
  leadNotTask?: string | null;
  search?: string | null;
  callStatus?: string[] | null;
  sourceTypes?: string[] | null;
}

export const clearQuery: IQuery = {
  balanceFinish: undefined,
  balanceStart: undefined,
  createdById: undefined,
  finishTimestamp: undefined,
  leadDeletedType: undefined,
  page: undefined,
  pipeId: undefined,
  responsibleById: undefined,
  setting: undefined,
  size: undefined,
  startTimestamp: undefined,
  taskFinishDate: undefined,
  taskStartDate: undefined,
  reasonsFRIds: undefined,
  tagIds: undefined,
  fields: undefined,
  pipeStatusIds: undefined,
  order: undefined,
  orderField: undefined,
  leadNotTask: undefined,
  callStatus: undefined,
  sourceTypes: undefined
};

interface IMethods {
  setQuery: (query: IQuery) => void;
  setQuerySingle: (query: IQuery) => void;
  setFilterCollapse: Dispatch<SetStateAction<IContext['filterCollapse']>>;
  setFilterOpen: Dispatch<SetStateAction<IContext['filterOpen']>>;
  setTab: (query: IContext['tab']) => void;
  setPipeDrawer: Dispatch<SetStateAction<IContext['pipeDrawer']>>;
}

export interface IContext extends IMethods {
  query: IQuery;
  filterCollapse: boolean;
  activePipe: Partial<crmModels.IPipeAll>;
  employeeObject: Partial<Record<number, crmModels.ILeadEmployee>>;
  filterOpen: boolean;
  tab: crmModels.CRMTabType;
  pipeDrawer: boolean;
  currentUserRole: UseQueryResult<CrmUserRoleModel, unknown>;
  requestParams?: Omit<IQuery, 'setting' | 'page' | 'size'>;
  employee: UseQueryResult<crmModels.ILeadEmployee[], unknown>;
  pipeAll: UseQueryResult<crmModels.IPipeAll[], unknown>;
  reasonsForRefusal: UseQueryResult<crmModels.IReasonsRefusal[], unknown>;
  tags: UseQueryResult<crmModels.ITags, unknown>;
}

const Context = createContext<IContext>({} as IContext);

export default Context;
